import "./Home.scss";
import Banner from "./Banner/Banner";
import Introduction from "./Introduction/Introduction";
import Category from "./Category/Category";
import Products from "../Products/Products";
import Accomodation from "../Accomodation/Accomodation";
const Home = () => {
    return (
    <div>
        <Banner/>
        <div className="main-content">
            <div className="layout">
                <Introduction/>
                <Category/>
                {/* <Accomodation/>
                <Products/> */}
                
            </div>
        </div>
    </div>
    );
};

export default Home;
